import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MemberService } from '@app/services/member.service';
import { forkJoin, Subscription } from 'rxjs';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-admin-remove-member',
  templateUrl: './admin-remove-member.component.html'
})
export class AdminRemoveMemberComponent implements OnDestroy, OnInit {
  
  member;
  primaryinstitution;
  result;
  subscriptions: Subscription[] = [];
  imageToShow: any;
  imagewidth;
  imageheight;
  message;
  form;
  constructor(
    private fb: FormBuilder,
    private memberService: MemberService,
    private adminService: AdminService,
    public confirmationService: ConfirmationService,
    public messageService: MessageService) { }

    ngOnInit() {
      this.form = this.fb.group({
        memberId: ['', Validators.required]
      });
    }

  confirmRemoveMember(): void {
      this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Är du säker på att du vill radera aktuell medlem?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.adminService.DeleteMemberPermanently(+this.form.get('memberId').value).subscribe(resp => {
          if (resp.item1) {
            this.member = '';
            this.message = resp.item2;
          } else {
            var alertMessage = 'Medlemmen är fadder till följande medlemmar och dessa fadderskap måste tas bort eller ersättas innan medlemmen kan tas bort:\n\n';
            for (const x of resp.item2) {
              alertMessage += x + '\n';
            }
            this.messageService.add({ sticky: true, severity: 'warn', summary: 'Medlem kan ej raderas', detail: alertMessage });
          }
        });
      },
      reject: () => {
      }
    });
  }

  getMemberInfo() {
    let memberid = this.form.get('memberId').value;
    this.memberService.getMemberById(+memberid).subscribe(response => {
      if (response) {
        this.member = response;
      }
    });
    this.memberService.getMemberPrimaryInstitution(+memberid).subscribe(response => {
      if (response) {
        this.primaryinstitution = response;
      }
    });

    let memberinfo = this.memberService.getMemberById(+memberid);
    let memberprimaryinstitution = this.memberService.getMemberPrimaryInstitution(+memberid);
    this.subscriptions.push(forkJoin([
      memberinfo,
      memberprimaryinstitution
    ]).subscribe(response => {
      this.member = response[0];
      this.primaryinstitution = response[1];
      this.getImageFromService(this.member.id);
    }));
  }

  getImageFromService(memberid) {
    this.memberService.GetMemberImageThumbnail(memberid).subscribe(data => {
      if (data !== null) {
        this.createImageFromBlob(data);
      } else {
        this.imageToShow = null;
      }
    }, error => {
      this.imageToShow = null;
    });
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;
      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getSize(imgdata) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width / 2;
      self.imageheight = image.height;
    });
    image.src = imgdata;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }
}
